/**
 * record-categories — lista kartotek systemowych z osią klasyfikacji „Kategoria"
 * (jedna, opcjonalna kategoria na rekord; tabela `record_categories`, migracja 0123 —
 * `apps/api/lib/records/categories.ts`). DYSTYNKTYWNA od „Grup" ze słownika (wiele na rekord).
 *
 * Zarządzanie listą żyje we WSPÓLNYM panelu ustawień „Kategorie" (`RecordCategoriesSettingsTab`),
 * podzielonym per kartoteka.
 *
 * `kartotekaKey` jest typowany względem wspólnego słownika `RECORD_CATEGORY_KARTOTEKA_KEYS`
 * (`@saas/shared`) — tego samego, którego backend używa jako allowlisty. Tu listujemy TYLKO te
 * kartoteki, które mają już wpięte UI kategorii (renderer w silniku formatek + `RecordCategoryPicker`
 * w formularzu) — świadomy PODZBIÓR słownika (np. `companies` jest w słowniku, ale bez UI = poza listą).
 * Rozszerzanie na kolejną kartotekę = dopisanie wpisu tutaj + renderer w jej configu silnika formatek.
 */
import type { RecordCategoryKartotekaKey } from '@saas/shared';

export interface RecordCategoryKartoteka {
  /** Klucz kartoteki w `record_categories.kartoteka_key`. Typowany względem wspólnego słownika. */
  kartotekaKey: RecordCategoryKartotekaKey;
  /** Klucz i18n etykiety kartoteki w selektorze panelu. */
  labelKey: string;
}

export const RECORD_CATEGORY_KARTOTEKI: readonly RecordCategoryKartoteka[] = [
  { kartotekaKey: 'contractors', labelKey: 'tenant.recordCategories.kartoteki.contractors' },
  { kartotekaKey: 'employees', labelKey: 'tenant.recordCategories.kartoteki.employees' },
  { kartotekaKey: 'users', labelKey: 'tenant.recordCategories.kartoteki.users' },
  { kartotekaKey: 'products', labelKey: 'tenant.recordCategories.kartoteki.products' },
  {
    kartotekaKey: 'contractor_contacts',
    labelKey: 'tenant.recordCategories.kartoteki.contractor_contacts',
  },
  { kartotekaKey: 'documents', labelKey: 'tenant.recordCategories.kartoteki.documents' },
  { kartotekaKey: 'tasks', labelKey: 'tenant.recordCategories.kartoteki.tasks' },
];
